import Teams from './container'

export default Teams
